module.exports = "<div class=\"mobile-connect-callback\">\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/mobile-connect-callback/mobile-connect-callback.html
// module id = 570
// module chunks = 0